import { Input } from '@/view/components/ui/input'

interface PasswordStepProps {
  password: string
  setPassword: (value: string) => void
}

export function PasswordStep({ password, setPassword }: PasswordStepProps) {
  return (
    <div className="space-y-4">
      <Input
        type="password"
        className="h-11 border-[1px] border-black04 font-medium placeholder:text-black04"
        placeholder="Insira sua senha atual"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </div>
  )
}
